import axios from "axios";
import { clearUserSession } from '../utils/session';

/**
 * Determines the API base URL based on the environment.
 * 
 * Priority 1: Production (window.location.origin)
 * Priority 2: Custom Environment Variable (REACT_APP_API_URL)
 * Priority 3: Development Hybrid Mode (Local IP or localhost)
 * 
 * @returns The resolved Base URL string.
 */
const getBaseUrl = () => {
  // 1. ÖNCELİK: PRODUCTION (Canlı Sunucu)
  // Canlı ortamdaysak ASLA environment variable'a veya hostname'e bakma.
  // Direkt Nginx'in sunduğu origin'i (örn: https://crm.triocare.com.tr) kullan.
  // Bu, production'da .env kazalarını %100 engeller.
  if (process.env.NODE_ENV === 'production') {
    return window.location.origin;
  }

  // 2. ÖNCELİK: Environment Override (Sadece Test/Dev İçin)
  // Eğer .env dosyasında özel bir override varsa onu kullan.
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }

  // 3. ÖNCELİK: Hibrit Dev Modu (Lokal Ağ)
  // Sadece bilgisayarınızda çalışırken devreye girer.
  // Tarayıcıdaki IP neyse (192.168.x.x veya localhost), backend'i onun 5000. portunda arar.
  return `${window.location.protocol}//${window.location.hostname}:5000`;
};

const backendURL = getBaseUrl();
export { backendURL };

const http = axios.create({
  baseURL: backendURL,
  withCredentials: true,
  headers: {
    "Content-type": "application/json"
  }
});

http.interceptors.response.use(
  (response) => response,
  (error) => {
    // [DÜZELTME] Sadece 401 Unauthorized logout tetikler
    // 403 Forbidden yetki hatası demek, session süresi dolduğu anlamına gelmez
    if (error.response && error.response.status === 401) {
      // Login sayfasında değilsek login'e at
      if (window.location.pathname !== '/login') {
        // Kullanıcının kendi çıkışıyla aynı temizlik (bkz. utils/session.ts):
        // filtreler de silinir, sonraki kullanıcıya sızmasın.
        clearUserSession();
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default http;